import { LoadablePaint } from '@confluence/loadable';

export const PageTreeSearchMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageTreeSearchMacro" */ '../src/PageTreeSearchMacroRenderer.tsx'
			)
		).PageTreeSearchMacroRenderer,
});
